import React from 'react';

import { useModalControls } from '@hooks';

import { SHORTCODE_BUTTONS, SHORTCODE_TYPE } from './constants';

export const useShortcodes = () => {
  const [type, setType] = React.useState();
  const modal = useModalControls(false);

  const toolbarItems = React.useMemo(() => Object.values(SHORTCODE_TYPE), []);

  const configure = React.useCallback(
    ({ editor }) => {
      SHORTCODE_BUTTONS.forEach((button) => {
        editor.ui.registry.addIcon(button.type, button.icon);
        editor.ui.registry.addButton(button.type, {
          icon: button.type,
          tooltip: button.tooltip,
          onAction: () => {
            setType(button.type);
            modal.show();
          },
        });
      });
    },
    [modal],
  );

  return { configure, type, modal, toolbarItems };
};
